import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import CamperService from '../../api/services/CamperService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Modal, Button } from 'react-bootstrap';
import Select from "react-select";
import AdminRestrictedDateService from '../../api/services/AdminRestrictedDateService';
const EditRestricted = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [camper, setCamper] = useState([]);
  const [camperSubscription, setCamperSubscription] = useState([]);
  const [RestrictedData, setRestrictedData] = useState([]);
  const [error, setError] = useState([]);
  const [isLoading, setisloading] = useState(true);
  const [RestrictedModal, setRestrictedModal] = useState(false);
  const [selectedCamperType, setSelectedCamperType] = useState(null);
  const [selectedCamperTypeId, setSelectedCamperTypeId] = useState('');
  const [selectedCamperSubscriptionType, setSelectedCamperSubscriptionType] = useState(null);
  const [selectedCamperSubscriptionTypeId, setSelectedCamperSubscriptionTypeId] = useState('');
  const getCamper = async () => {
    try {
      let camper = await CamperService.index().json();

      var responsedata = camper.data.filter(function (item) {
        return item.camper_type_id == 1 && item.status == 1
      });

      setCamper(responsedata);

      let Restrictedatedata = await AdminRestrictedDateService.show(params.id).json();
      setRestrictedData(Restrictedatedata.data)

      const getSelected = [].concat.apply([], Restrictedatedata.data.camper_ids.map((element) => {
        return responsedata.filter(c => c.id == element);
      }));
      if (Restrictedatedata.data.camper_ids.length === responsedata.length) {
        var selectedCamperType = responsedata.map(option => option.id);

        setSelectedCamperType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
        setSelectedCamperTypeId(selectedCamperType);
      }
      else {
        const selectedCamperTitles = getSelected.map(option => ({
          value: option.id,
          label: option.title,
        }));

        setSelectedCamperType(selectedCamperTitles);
        setSelectedCamperTypeId(getSelected.map(option => option.id));

      }
      //subscription
      var responsesubscription = camper.data.filter(function (item) {
        return item.camper_type_id == 2 && item.status == 1
      });
      setCamperSubscription(responsesubscription)
      const getsubscriptionSelected = [].concat.apply([], Restrictedatedata.data.campersubscription_ids.map((element) => {
        return responsesubscription.filter(c => c.id == element);
      }));

      if (Restrictedatedata.data.campersubscription_ids.length === responsesubscription.length) {
        var selectedCamperType = responsesubscription.map(option => option.id);

        setSelectedCamperSubscriptionType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
        setSelectedCamperSubscriptionTypeId(selectedCamperType);
      }
      else {
        const selectedCamperTitles = getsubscriptionSelected.map(option => ({
          value: option.id,
          label: option.title,
        }));

        setSelectedCamperSubscriptionType(selectedCamperTitles);
        setSelectedCamperSubscriptionTypeId(getsubscriptionSelected.map(option => option.id));

      }
      setisloading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      getCamper();
    }
    else {
      navigate('/')
    }
  }, []);

  const onSubmitForm = async (event) => {
        event.preventDefault();
        console.log(camperSubscription,"selectedCamperSubscriptionTypeId")
        try {
          var userData = {
            "startdate": event.target.start_date.value,
            "enddate": event.target.end_date.value,
            "camper_ids": selectedCamperTypeId ? selectedCamperTypeId : [],
            "campersubscription_ids": selectedCamperSubscriptionTypeId.length > 0 ? selectedCamperSubscriptionTypeId : []
          }
          var startDate = new Date(userData.startdate);
          var endDate = new Date(userData.enddate);
          if (startDate > endDate) {
            setError("The Start Date cannot be later than the End Date.");
            return; // Exit the function if the dates are not valid
          }
          else if (selectedCamperTypeId.length === 0 && selectedCamperSubscriptionTypeId.length === 0) {
            setError("Please choose either a Rent Camper, a Subscription Camper, or both.");
            return;
          }
          else {
            let responseData = await AdminRestrictedDateService.update(params.id, userData).json()
            if (responseData.status === false) {
              setError(responseData.message);
              return;
            }
            if (responseData.status === true) {
              setRestrictedModal(true)
            }
            // if (responseData.status === true) {
            //   navigate("/admin/restricted-list"); // Redirect on success
            // }
            setError(responseData.errors)
          }
        } catch (error) {
          if (error.name === 'HTTPError') {
            const errorJson = await error.response.json();
            setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
          }
        }
    
      };

  // const onSubmitForm = async (event) => {
  //   event.preventDefault();
  //   setError("")
  //   try {
  //     var userData = {

  //       "startdate": event.target.start_date.value,
  //       "enddate": event.target.end_date.value,
  //       "camper_ids": selectedCamperTypeId ? selectedCamperTypeId : [],
  //       "campersubscription_ids": selectedCamperSubscriptionTypeId ? selectedCamperSubscriptionTypeId : []
  //     }
  //     var startDate = new Date(userData.startdate);
  //     var endDate = new Date(userData.enddate);
  //     if (startDate > endDate) {
  //       setError("The Start Date cannot be later than the End Date.");
  //       return; // Exit the function if the dates are not valid
  //     }
  //     if (selectedCamperTypeId.length === 0 && selectedCamperSubscriptionTypeId.length === 0) {
  //       setError("Please choose either a Rent Camper, a Subscription Camper, or both.");
  //       return;
  //     }
  //     else {
  //       let responseData = await AdminRestrictedDateService.update(params.id, userData).json()
  //       if (responseData.status === false) {
  //         setError(responseData.message);
  //         return;
  //       }
  //       if (responseData.status === true) {
  //         setRestrictedModal(true)
  //       }
  //     }
  //   } catch (error) {
  //     if (error.name === 'HTTPError') {
  //       const errorJson = await error.response.json();
  //       setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
  //     }
  //   }

  // };
  const handleSelectCamperType = (selectedOption) => {
    var selectedCamperType;
    if (selectedOption.some(option => option.value === 'select-all-vehicles')) {
      selectedCamperType = camper.map(option => option.id);
      setSelectedCamperType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
      setSelectedCamperTypeId(selectedCamperType);
    } else {

      selectedCamperType = selectedOption.map(option => option.value);
      setSelectedCamperType(selectedOption);
      setSelectedCamperTypeId(selectedCamperType);
    }
  }
  const handleSelectCamperSubscriptionType = (selectedOption) => {
    var selectedCamperType;
    if (selectedOption.some(option => option.value === 'select-all-vehicles')) {
      selectedCamperType = camperSubscription.map(option => option.id);
      setSelectedCamperSubscriptionType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
      setSelectedCamperSubscriptionTypeId(selectedCamperType);
    } else {

      selectedCamperType = selectedOption.map(option => option.value);
      setSelectedCamperSubscriptionType(selectedOption);
      setSelectedCamperSubscriptionTypeId(selectedCamperType);
    }
  }
  return (
    <>
      <MainPagetitle mainTitle="Edit Restricted Dates" pageTitle={'Edit Restricted Dates'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Edit Restricted Dates</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='start_date' id="val-username"
                        defaultValue={
                          RestrictedData.startdate
                            ? RestrictedData.startdate
                            : ''
                        }
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='end_date' id="val-username"
                        defaultValue={
                          RestrictedData.enddate
                            ? RestrictedData.enddate
                            : ''
                        }
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Rent Camper <span className="text-danger">*</span></label>
                      <Select
                        name="camper_ids"
                        value={selectedCamperType}
                        placeholder="Select Vehicles"
                        options={[
                          { value: 'select-all-vehicles', label: 'Select All Vehicles' }, // Add 
                          ...(camper?.map(attr => ({
                            value: attr.id,
                            label: attr.title,
                          })) || []),
                        ]}
                        isMulti
                        onChange={(selectedOption) => handleSelectCamperType(selectedOption)}
                        className={`select2-selection`} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Subscription Camper <span className="text-danger">*</span></label>
                      <Select
                        name="camper_ids"
                        value={selectedCamperSubscriptionType}
                        placeholder="Select Vehicles"
                        options={[
                          { value: 'select-all-vehicles', label: 'Select All Vehicles' }, // Add 
                          ...(camperSubscription?.map(attr => ({
                            value: attr.id,
                            label: attr.title,
                          })) || []),
                        ]}
                        isMulti
                        onChange={(selectedOption) => handleSelectCamperSubscriptionType(selectedOption)}
                        className={`select2-selection`} />
                    </div>

                  </div>

                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={RestrictedModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setRestrictedModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Restricted Date Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/restricted-list'} variant="danger light" onClick={() => setRestrictedModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditRestricted;